<template>
<div  :aria-busy="loading ? 'true' : 'false'">
	<div v-if="!loading">
		<alert :conditional="user.fb_page_id === null && user.organization.is_mandatoaberto !== 0"
			:classFather="'alert'"
			:message="'alert-facebook'"
			:iconClass="'icon fas fa-warning'"
			:linkShow="true"
			:linkTo="'/perfil'"
			:linkText="'configure'"
			:altLink="'configure-facebook'"
			:close-button="true">
		</alert>

		<section class="content__custom">
			<div class="main-title" :data-intro="'tour-guide__supporters' | translate" v-intro-step="1">
				<h1 class="followers">
					{{ 'followers' | translate | titleCase }}
				</h1>
				<h2>{{ 'supporters-subtitle' | translate | capitalize }}</h2>
			</div>

			<ul class="counters" v-if="totalItems">
				<li class="counters__supporters" v-if="totalItems > 1">
					 {{ (totalItems) ? totalItems : '0' }} {{ 'supporters' | translate | lowercase }}
				</li>
				<li class="counters__supporters" v-else>
						 {{ (totalItems) ? totalItems : '0' }} {{ 'supporter' | translate | lowercase }}
				</li>
			</ul>
			<div v-if="supporters">
				<div v-if="supporters.length > 0">

						<table class="table--fixed table-navigation">
							<thead>
								<tr>
									<th class="name-cell">{{ 'name' | translate | titleCase }}</th>
									<th class="email-cell">{{ 'email' | translate | titleCase }}</th>
									<th class="phone-cell">{{ 'phone' | translate | titleCase }}</th>
									<th class="groups-cell">{{ 'groups' | translate | titleCase }}</th>
									<th class="intention-cell">{{ 'intentions' | translate | titleCase }}</th>
									<th class="date-cell">{{ 'date-of-interaction' | translate | titleCase }}</th>
								</tr>
							</thead>
							<tfoot v-if="supporters.length >= 10">
								<tr>
									<th class="name-cell">{{ 'name' | translate | titleCase }}</th>
									<th class="email-cell">{{ 'email' | translate | titleCase }}</th>
									<th class="phone-cell">{{ 'phone' | translate | titleCase }}</th>
									<th class="groups-cell">{{ 'groups' | translate | titleCase }}</th>
									<th class="intention-cell">{{ 'intentions' | translate | titleCase }}</th>
									<th class="date-cell">{{ 'date-of-interaction' | translate | titleCase }}</th>
								</tr>
							</tfoot>
							<tbody>
								<tr v-for="person in supporters" :key="person.id" @click="detailsSupporters(person.id)">
									<td :title="'name' | translate" class="name-cell">{{ person.name }}</td>
									<td :title="'email' | translate" class="email-cell">{{ person.email }}</td>
									<td :title="'phone' | translate" class="intention-cell">{{ person.cellphone }}</td>
									<td :title="'groups' | translate" class="groups-cell">{{ person.groups.length }}</td>
									<td :title="'intentions' | translate" class="intention-cell">{{ person.intents.length }}</td>
									<td :title="'first-interaction' | translate" class="date-cell">{{ person.created_at | date }}</td>
								</tr>
							</tbody>
						</table>

						<pagination
						:classNames="'pagination-arrows pull-right'"
						dispatchToCall="getSupporters"
						:itemsPerPageProp="session.results"
						:totalItensPagesProps="totalPages"
						:totalItens="totalItems"
						:totalPagesProp="this.totalPages"
						></pagination>
				</div>
				<div v-else>
					<p class="empty-state">
						{{ 'no-supporters' | translate | capitalize }}
					</p>
				</div>
		</div>

		</section>
	</div>

</div>
</template>
<script>

import alert from '../../components/alert/alert.vue';
import pagination from '../../components/pagination/pagination.vue';

export default {
	name: 'supporters',
	components: {
		alert,
		pagination,
	},
	data() {
		return {
			loading: false,
			session: {
				page: 1,
				results: 20,
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
		};
	},
	computed: {
		supporters() {
			return (this.$store.state.recipient.recipient || {}).recipients || {};
		},
		user() {
			return this.$store.state.user;
		},
		totalItems() {
			return this.$store.state.recipient.recipient.itens_count;
		},
		totalPages: {
			get() {
				return this.totalItems / this.session.results || 0;
			},
			set() {
			},
		},
	},
	methods: {
		toggleLoading() {
			this.loading = !this.loading;
		},
		paginationData() {
			this.supporters = this.supporters;
		},
		detailsSupporters(id) {
			this.$router.push({ path: '/seguidor', query: { id } });
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getSupporters', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
	watch: {
		supporters() {
			if (this.$store.state.recipient.supporters.recipients) {
				this.totalPages = this.$store.state.recipient.supporters.recipients;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/recipient/supporters.vue